import React from "react";
import { Link } from "react-router-dom";
import {
  Title,
  Button,
  EmptyState,
  EmptyStateVariant,
  EmptyStateIcon,
  EmptyStateBody,
  EmptyStatePrimary,
} from "@patternfly/react-core";
import SearchIcon from "@patternfly/react-icons/dist/js/icons/search-icon";

export default () => {
  return (
    <EmptyState variant={EmptyStateVariant.xl}>
      <EmptyStateIcon icon={SearchIcon} />
      <Title size="lg" headingLevel="h4">
        Page not found
      </Title>
      <EmptyStateBody>
        This page does not exist or you don't have enough permission to access.
        Please visit the product page.
      </EmptyStateBody>
      <EmptyStatePrimary>
        <Button variant="link">
          <Link to={`/product`}>Product Page</Link>
        </Button>
      </EmptyStatePrimary>
    </EmptyState>
  );
};
